export default __webpack_public_path__ + "static/media/编组 25.53f95083.png";